import { Common } from './common';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findUrlById(id: string): Promise<{ url: string }> {
    const url = this.common.constructPath(
      `/patient-advisory-documents/${id}/url`,
    );

    return this.common.getJSON(url);
  }
}
